export default {
  getError(state) {
    return state.error;
  },
  getFilterError(state) {
    return state.filterError;
  },
  getNoMatch(state) {
    return state.noMatch;
  },
  getOneMineral(state) {
    return state.oneMineral;
  },
  /**
   *
   * @returns {String} with Title in the appropriate language
   */
  getPageTitle(state) {
    return state.currentTitle;
  },
  getQuerySuggestions(state) {
    return state.querySuggestions.sort(
      new Intl.Collator(state.currentLanguage).compare,
    );
  },
  getResults(state) {
    return state.results;
  },
  hasQuery(state) {
    if (state.queryArray.length > 0 && state.results === 0);
    return state.queryArray;
  },
  loadSelectOptions(state) {
    return state.selectOptions;
  },
  hasMineral(state) {
    return state.hasMineral;
  },
  getFilterResults(state) {
    return state.filterResults;
  },
  getRockMineral(state) {
    return state.rockMineral;
  },
  loadFilterOptions(state) {
    return state.filterOptions;
  },
};
